/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = "id", pid = "parentId") {
  var res = [];
  var temp = {};
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i];
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]["children"]) {
        temp[data[k][pid]]["children"] = [];
      }
      if (!temp[data[k][pid]]["_level"]) {
        temp[data[k][pid]]["_level"] = 1;
      }
      data[k]["_level"] = temp[data[k][pid]]._level + 1;
      temp[data[k][pid]]["children"].push(data[k]);
    } else {
      res.push(data[k]);
    }
  }
  return res;
}

//列表转树列表
export const listToTree = (array = [], key = "id", parentKey = "parentId") => {
  let newArray = [];
  let newData = [].concat(array);
  let deep = 0;
  newData.forEach((item) => {
    const parent = newData.find((node) => node[key] === item[parentKey]);
    if (parent) {
      parent.children = parent.children || [];
      parent.children.push(item);
    } else {
      newArray.push(item);
    }
  });
  //增加深度对象
  // function mapTree(array) {
  //     array.forEach((val, idx) => {
  //         val.idx = `${idx + 1}`
  //         if (idx > 0) {
  //             val.deep = array[idx - 1].deep
  //         } else {
  //             val.deep = deep
  //         }
  //         if (val.children) {
  //             deep = val.deep + 1
  //             mapTree(val.children)
  //         }
  //     })
  // }
  // mapTree(newArray)
  return newArray;
};
